<template>
  <div class="themeBody" :data-theme="themeMode">
    <go-back-button :is-align-center="true" v-if="$store.state.isInSlicer == true"
                    class="policiesGoBackButton">
      <template v-slot:body>
        删除账号协议
      </template>
    </go-back-button>

    <div style="text-align: left" v-html="articleContent"></div>
  </div>
</template>

<script>
import {articleDetail} from "@/api/api";

export default {
  data() {
    return {
      articleTitle: `<h1>删除账号协议</h1>`,
      articleContent: "",
    }
  },
  computed: {
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
  },
  created() {
    if (this.$store.state.isInSlicer == true) {
      this.articleTitle = ``
    }
    this.articleContent = `
<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>删除账号协议</title>
</head>

<style data-emotion="portal-css-global hcq6pi">
    html {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        box-sizing: border-box;
        -webkit-text-size-adjust: 100%;
    }

    *,
    *::before,
    *::after {
        box-sizing: inherit;
    }

    strong{
        font-size: 22px;
        font-weight: 700;
    }

    b {
        font-weight: 700;
    }

    body {
        margin: 0;
        color: #212B36;
        line-height: 1.5;
        font-size: 1.6rem;
        font-family: "Open Sans", "system-ui", "Segoe UI", Roboto, Oxygen, Ubuntu, "Fira Sans", "Droid Sans", "Helvetica Neue", sans;
        font-weight: 400;
        background-color: #ffffff;
    }

    @media print {
        body {
            background-color: #fff;
        }
    }

    body::backdrop {
        background-color: #EEEEEE;
    }

    body {
        font-size: 16px;
    }
</style>

<style>
    .article-css {
        max-width: 800px;
        margin: 0 auto;
        padding: 0 20px;
        overflow: hidden;
    }

    .article-css a {
        color: #2196f4;
    }

    .article-css p {
        padding-bottom: 15px;
        color: #757575;
        line-height: 1.5;
    }

    .article-css h1 {
        font-size: 22px;
    }
</style>

<body>
    <div class="article-css">
        ` + this.articleTitle +
        `
        <p>用户账号用于QIDI Lab为个人提供的各种云端服务，我们为用户提供了删除其个人账号的选项，以便根据<a href="#/policies/privacy">隐私政策</a>永久和不可逆转地删除与您账号有关的所有个人数据。</p>
        <p>1.当您登录您的账号时,您可以访问 QIDI Link中的账号安全页面以删除您的账号。</p>
        <p>2.如果您需要取消订阅,可以按照电子邮件中的说明随时取消订阅。</p>
        <p>3.删除账号后，只要账号尚未被 QIDI Lab 新用户占用，您就可以使用该同一账号重新注册。</p>
        <p>4.收到删除账号请求后 45 天，您的账号和所有数据将被永久删除，您将无法找回信息。在这 45 天内，这些内容仍需要遵守QIDI Lab<a href="#/policies/terms">用户协议</a>和<a href="#/policies/privacy">隐私政策</a>。</p>
        <p>5.账号删除最多可能需要 90 天。 90
            天后，您的个人信息副本可能会保留在备份存储(用于在发生灾难、软件故障或其他数据丢失时恢复数据)中。我们也可能因法律问题、违反<a href="#/policies/terms">用户协议</a>、预防造成伤害、订单履行及/或技术限制等原因，保存您的个人信息。如果是这种情况,我们会安全地存储您的个人信息并将其隔离不作任何进一步处理，直到备份可以删除或匿名为止。请阅读<a href="#/policies/privacy">隐私政策</a>详细了解相关内容。
        </p>
    </div>
</body>

</html>
      `
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';

>>> .article-css{
  @include background_color('background_color');
  @include font_color('text-color');
}

</style>



// WEBPACK FOOTER //
// src/views/policies/deleteAccountPrivacy.vue